import React from "react";
import './Description.scss'
const Description = () => {
  return (
    <section className="Disclaimers-module--container--ptFl5">
    <h2 className="sr-only" />
    <p className="Disclaimers-module--paragraph--br0XU">
      <span>
        <span data-disclaimer="¹ EPA estimated range ratings when equipped with 19” wheels: 520 Dream Edition R/471 Dream Edition P/516 Grand Touring. Actual results may vary. Air Pure and Air Touring 406 range are based upon manufacturer’s projected EPA estimated range when equipped with 19” wheels. Projected EPA estimated ranges are subject to change.  Air Sapphire is in pre-production. Range estimates are not currently available.">
          <span data-disclaimer="¹ EPA estimated range ratings when equipped with 19” wheels: 520 Dream Edition R/471 Dream Edition P/516 Grand Touring. Actual results may vary. Air Pure and Air Touring 406 range are based upon manufacturer’s projected EPA estimated range when equipped with 19” wheels. Projected EPA estimated ranges are subject to change.  Air Sapphire is in pre-production. Range estimates are not currently available.">
            ¹
          </span>
        </span>
      </span>
      FLUX is Africa's exciting entry into the fully electric automobile space. Step up to full electric power with a huge range of over 800km on a single 30 min recharge. The next time there’s a gas shortage, and all your friends are waiting in line - YOU won't care. Unlike other continents that push pricey compacts for the working person, FLUX specializes in premium elite design and the very latest cutting-edge features. Africa deserves nothing less. Show the world Africa is leading the way to the future.
    </p>
    <p className="Disclaimers-module--paragraph--br0XU">
      <span>
        <span data-disclaimer="² Excludes tax, title, license, options and destination fees. Pricing not currently available in non-US markets. Additional state and local incentives may also be available. A tax advisor should be consulted regarding individual tax treatment. ">
          <span data-disclaimer="² Excludes tax, title, license, options and destination fees. Pricing not currently available in non-US markets. Additional state and local incentives may also be available. A tax advisor should be consulted regarding individual tax treatment. ">
            ²
          </span>
        </span>
      </span>
      Optional Armored version - Wealthy industrialists and high placed politicians contacted us early to create a special Armored Version of our FLUX Fully Electric Sedan and SUV. We are happy to oblige. Now ride in complete safety and enhanced security that can stop trouble in its tracks. All while enjoying an elite look that exudes continental style.
    </p>
    <p className="Disclaimers-module--paragraph--br0XU">
      <span>
        <span data-disclaimer="³ 1,200+ max horsepower is only available with Air Sapphire.">
          <span data-disclaimer="³ 1,200+ max horsepower is only available with Air Sapphire.">
            ³
          </span>
        </span>
      </span>
      Cutting-edge Self Driving Ability lets you sit back, relax, and let the car be your driver.
    </p>
    <p className="Disclaimers-module--paragraph--br0XU">
      <span>
        <span data-disclaimer="⁴ 1,050 max horsepower is only available with Grand Touring Performance.">
          <span data-disclaimer="⁴ 1,050 max horsepower is only available with Grand Touring Performance.">
            ⁴
          </span>
        </span>
      </span>
      Powerful All Wheel Drive handles even the toughest terrain. potholes? No problem.
    </p>
    <p className="Disclaimers-module--paragraph--br0XU">
      <span>
        <span data-disclaimer="⁵ EPA estimated range ratings when equipped with 19” wheels for Flux Air Grand Touring. Actual results may vary. Projected EPA estimated ranges are subject to change.">
          <span data-disclaimer="⁵ EPA estimated range ratings when equipped with 19” wheels for Flux Air Grand Touring. Actual results may vary. Projected EPA estimated ranges are subject to change.">
            ⁵
          </span>
        </span>
      </span>
      Impressive Touch Screen Dashboard with Advanced Parking Sensor to keep your FLUX ride scratch free and pristine.
    </p>
  </section>
  );
};

export default Description;
